export function isDimensionsCustomOrNoValue(value: string): boolean {
  const val = (value ? value.trim().toLowerCase() : '');
  if (val === '') {
    return false;
  }

  return isCustomDimensionsValue(val) || isDimensionsNoValue(val);
}

export function isCustomDimensionsValue(value: string): boolean {
  const val = (value ? value.trim().toLowerCase() : '');
  if (val === '') {
    return false;
  }

  const checkList = ['sondermass', 'sondermaß'];

  return checkList.includes(val);
}

export function isDimensionsNoValue(value: string): boolean {
  const val = (value ? value.trim().toLowerCase() : '');
  if (val === '') {
    return false;
  }

  const checkList = ['novalue'];

  return checkList.includes(val);
}
